import React from "react";
import "../OurStory.css";

import {
  FaLightbulb,
  FaBuilding,
  FaLaptopCode,
  FaRocket,
} from "react-icons/fa";

const timeline = [
  {
    icon: <FaLightbulb />,
    year: "The Vision",
    title: "A Vision to Transform Businesses",
    description:
      "VisionVote Technologies was founded with the belief that technology should empower organizations, simplify operations, and create meaningful business impact through innovation.",
  },
  {
    icon: <FaBuilding />,
    year: "Company Formation",
    title: "Building a Strong Foundation",
    description:
      "Established as VisionVote Technologies Private Limited, our mission is to deliver high-quality software development and strategic IT consulting services for businesses of every size.",
  },
  {
    icon: <FaLaptopCode />,
    year: "Innovation",
    title: "Delivering Modern Digital Solutions",
    description:
      "We specialize in custom software development, web applications, mobile apps, cloud solutions, AI integration, and digital transformation tailored to client needs.",
  },
  {
    icon: <FaRocket />,
    year: "Future",
    title: "Growing with Our Clients",
    description:
      "Our journey has only begun. We continue to innovate, adopt emerging technologies, and build long-term partnerships that help businesses succeed in a rapidly evolving digital world.",
  },
];

const OurStory = () => {
  return (
    <section className="our-story">

      <div className="company-container">

        <span className="section-tag">
          OUR STORY
        </span>

        <h2>
          Every Great Innovation Begins
          <span> With a Vision</span>
        </h2>

        <p className="story-intro">
          At VisionVote Technologies, our journey is driven by innovation,
          collaboration, and a commitment to helping businesses embrace the
          future with confidence. Every project we undertake reflects our
          passion for technology and our dedication to creating solutions that
          deliver lasting value.
        </p>

        <div className="timeline">

          {timeline.map((item, index) => (

            <div className="timeline-item" key={index}>

              <div className="timeline-icon">
                {item.icon}
              </div>

              <div className="timeline-content">

                <span className="timeline-year">
                  {item.year}
                </span>

                <h3>{item.title}</h3>

                <p>{item.description}</p>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
};

export default OurStory;